// Measure the public arrival, then stop before any discovery work.
// A saved draft or non-campaign URL never enters the public scope.
declare global {
  interface Window {
    "ga-disable-G-7X7V3F31TL": boolean;
  }
}

const campaignKeys = new Set(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]);
let closed = false;

function setScope(allowed: boolean) {
  if (!allowed) window["ga-disable-G-7X7V3F31TL"] = true;
  document.documentElement.dataset.analyticsScope = allowed ? "public" : "private";
  document.body.dataset.analyticsScope = allowed ? "public" : "private";
  document.body.dataset.analyticsPath = "/";
  window.dispatchEvent(new CustomEvent("pitchdog:analytics-scope", { detail: { allowed, path: "/" } }));
}

export function enterDiscovery() {
  closed = true;
  setScope(false);
}

export function publicLandingReady() {
  if (closed) return;
  try {
    const url = new URL(window.location.href);
    const campaignOnly = [...url.searchParams].every(([key, value]) => campaignKeys.has(key) && /^[a-zA-Z0-9_.-]{1,100}$/.test(value));
    if (url.pathname !== "/" || url.hash || !campaignOnly || localStorage.getItem("pd-discovery-active-draft")) {
      enterDiscovery();
      return;
    }
    setScope(true);
  } catch {
    enterDiscovery();
  }
}

setScope(false);
// Capture runs before React's handlers and before field values can change.
for (const name of ["pointerdown", "focusin", "keydown", "beforeinput", "input", "change", "submit", "click"]) {
  document.addEventListener(name, (event) => {
    if (event.target instanceof Element && event.target.closest(".intro form")) enterDiscovery();
  }, true);
}
window.addEventListener("hashchange", enterDiscovery);
window.addEventListener("popstate", enterDiscovery);
